import type { ComputedRef, InjectionKey } from 'vue'

export interface UploadContext {
  accept: ComputedRef<string>
  directory: ComputedRef<boolean>
}

export const uploadContextKey: InjectionKey<UploadContext> =
  Symbol('uploadContextKey')

export const FILE_LIST_ICON = ['video', 'radio', 'excel', 'pdf', 'ppt', 'word']
